import PropTypes from 'prop-types'
import React from 'react'

const ReviewContentBox = props => {
  if (props.children.length === 0) return <div />
  return (
    <div>
      <h3 className="review_header">{props.title}</h3>
      <h5 className="review_header">{props.subtitle}</h5>
      <div className="data_container review_content_container">
        {props.children}
      </div>
    </div>
  )
}

ReviewContentBox.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
}

export default ReviewContentBox
